import * as React from "react";
const SvgFiRrPumpkin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pumpkin_svg__a)">
      <path
        fill="#062147"
        d="M17 6a4.1 4.1 0 0 0-1.639.362A4.96 4.96 0 0 0 13.049 6c.426-4.382 3.878-4.78 3.951-3a1 1 0 1 0 0 2 2 2 0 0 0 2-2c-.3-3.828-5.018-3.987-6.99-.437-.582-1.045-2.8-3.664-3.9-2.01A1 1 0 0 0 8.553 1.9c1.425.712 2.214 2.062 2.4 4.105a5 5 0 0 0-2.316.362C4.373 4.824.035 8.846 0 15c.045 6.1 4.272 10.1 8.464 8.666.79.377 1.696.431 2.525.151.652.245 1.37.245 2.022 0a3.36 3.36 0 0 0 2.523-.151c4.192 1.433 8.421-2.567 8.466-8.667 0-5.633-3.56-9-7-9M2 15c0-4.027 2.148-6.558 4.4-6.943-3.1 3.03-3.107 10.757-.182 13.85C4.033 21.419 2 18.917 2 14.999m4 0c0-3.447 1.569-5.66 2.984-6.552-1.343 2.617-1.257 10.982.048 13.287C7.553 20.964 6 18.54 6 15m6 7c-2.671.2-2.629-14.178 0-14 2.634-.17 2.666 14.2 0 14m2.968-.265c1.3-2.306 1.391-10.67.048-13.287 3.986 2.275 3.876 11.119-.048 13.287m2.811.172c2.926-3.094 2.913-10.821-.182-13.85 5.746.978 5.849 12.619.182 13.85"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pumpkin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPumpkin;
